export enum SubscriptionRoutes {
  Plans = "/subscription",
  Card = "/subscription/card",
  ThankYou = "/subscription/thank-you",
  Invoices = "/subscription/invoices",
  AccountDetails = "/subscription/account-details",
  AccountDetailsWithOpenedBilling = "/subscription/account-details#billing-details",
  CancelAccount = "/subscription/cancel-account",
  Shopify = "/subscription/shopify",
  Partner = "/subscription/partner",
  UpgradeBusiness = `${SubscriptionRoutes.Plans}#upgrade-business`,
}
